import ImagesRoute from "../assets/ImagesRoute";

export const effectList = [
  {
    name: "AudioAnalyzer",
    img: ImagesRoute.audioanalyzer_icon,
    explain: "音の波形を表示。各周波数に合わせて折れ線が上下します。",
  },
  {
    name: "PixcelAnalyzer",
    img: ImagesRoute.pixcelanalyzer_icon,
    explain: "音の波形を表示。各周波数に合わせてボックスが表示されます。",
  },
  {
    name: "VolumeAnalyzer",
    img: ImagesRoute.volumeanalyzer,
    explain: "音量に合わせて線が上下します。",
  },
];
